import React, { useState } from 'react';
import { FUEL_TYPES } from '../data/fuelData';
import './FuelGuide.scss';

function RatingBars({ count, total = 5, recommended }) {
  return (
    <div className="rating-bars">
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={`rating-bars__bar${i < count ? ' rating-bars__bar--filled' : ''}${recommended ? ' rating-bars__bar--rec' : ''}`}
        />
      ))}
    </div>
  );
}

function FuelCard({ fuel, expanded, onToggle }) {
  return (
    <div
      className={`fuel-card${fuel.recommended ? ' fuel-card--recommended' : ''}`}
      onClick={onToggle}
    >
      {fuel.recommended && (
        <div className="fuel-card__rec-badge">✓ Most Recommended</div>
      )}

      <div className="fuel-card__icon">{fuel.icon}</div>
      <div className="fuel-card__name">{fuel.name}</div>
      <div className="fuel-card__tag">{fuel.tag}</div>
      <p className="fuel-card__desc">{fuel.desc}</p>

      <RatingBars count={fuel.rating} recommended={fuel.recommended} />
      <div className="fuel-card__rating-label">Quality {fuel.rating}/5</div>

      {expanded && (
        <div className="fuel-card__expanded">
          <div className="fuel-card__pros-cons">
            <div className="fuel-card__pros">
              <div className="fuel-card__list-label">✓ Pros</div>
              {fuel.pros.map((p, i) => (
                <div key={i} className="fuel-card__list-item">{p}</div>
              ))}
            </div>
            <div className="fuel-card__cons">
              <div className="fuel-card__list-label">✕ Cons</div>
              {fuel.cons.map((c, i) => (
                <div key={i} className="fuel-card__list-item">{c}</div>
              ))}
            </div>
          </div>
        </div>
      )}

      <button className="fuel-card__toggle">
        {expanded ? '↑ Less' : '↓ More'}
      </button>
    </div>
  );
}

export default function FuelGuide() {
  const [expanded, setExpanded] = useState(null);

  const toggle = (id) => setExpanded((prev) => (prev === id ? null : id));

  return (
    <section id="fuel-guide" className="fuel-guide">
      <div className="fuel-guide__inner">
        <div className="fuel-guide__header">
          <p className="fuel-guide__label">Educational · Always Verify with Handbook</p>
          <h2 className="fuel-guide__title">Understanding Fuel Types</h2>
          <p className="fuel-guide__desc">
            Not all fuels are equal. Here's a complete breakdown of quality, performance,
            emissions, and cost — including electric — to help you make the best choice
            for your vehicle and budget. Tap any card to expand.
          </p>
        </div>

        <div className="fuel-guide__grid">
          {FUEL_TYPES.map((fuel) => (
            <FuelCard
              key={fuel.id}
              fuel={fuel}
              expanded={expanded === fuel.id}
              onToggle={() => toggle(fuel.id)}
            />
          ))}
        </div>

        <div className="fuel-guide__callout">
          <span className="fuel-guide__callout-icon">💡</span>
          <p>
            <strong>General Rule:</strong> Use E10 for standard petrol cars (2011+), E5 for
            performance or pre-2011 petrol vehicles, B7 for diesel engines. Consider electric
            if you drive under 150 miles daily and have home charging. Always check your fuel
            filler cap or handbook — misfuelling can cause severe engine damage.
          </p>
        </div>
      </div>
    </section>
  );
}
